export default __webpack_public_path__ + "static/media/295.0e9306fe.jpg";